'use client';

import { createContext, type ReactNode, useContext } from 'react';
import type { RoundupPick } from './getRoundupPicksSummary';

const RoundupPicksSummaryContext = createContext<RoundupPick[]>([]);

/**
 * Makes a roundup's auto-populated picks summary available to a
 * CreditCardsRoundupPicksSummary node no matter how deeply it's nested in the
 * structured content tree (e.g. inside an Accordion/AccordionItem). Nested renderers
 * (Document, Container, Accordion, etc.) recurse via `renderStructuredContent` without
 * forwarding component-specific props, so a prop can't reach a nested node — context can.
 */
export function RoundupPicksSummaryProvider({
  picks,
  children,
}: {
  picks: RoundupPick[];
  children: ReactNode;
}) {
  return (
    <RoundupPicksSummaryContext.Provider value={picks}>
      {children}
    </RoundupPicksSummaryContext.Provider>
  );
}

export function useRoundupPicksSummary() {
  return useContext(RoundupPicksSummaryContext);
}
